import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { GlobalModule } from '@app/core/global.module';
import { CustomMaterialModule } from '@app/core/material.module';
import { NotifyListComponent } from '@app/layout/side-menu/childrens/notify-list/component/notify-list.component';
import { DynamicFieldsModule } from '@app/modules/dynamic-fields/dynamic-fields.module';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { PanelToolsModule } from '@components/panel-tools/panel-tools.module';
import { SKELETON_LOADER_TOKEN } from '@constants/diConstant';
import { SKELETON_LOADER_CONFIG } from '@constants/mainConstants';
import { CustomScrollDirective } from '@directives/custom-scroll/custom-scroll.directive';
import { ShowTooltipModule } from '@directives/show-tooltip/show-tooltip.module';
import { SkeletonDirectiveModule } from '@directives/skeleton/skeleton-directive.module';
import { FuiButtonComponent, FuiIconComponent } from '@fui/fui-components';
import { UserListDialogModule } from '@modules/users/dialogs/user-list-dialog/modules/user-list-dialog.module';
import { MyDateModule } from '@pipes/my-date/my-date.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MenuButtonComponent } from '../childrens/menu-button/menu-button.component';
import { SideMenuComponent } from '../component/side-menu.component';
import { MenuEditDialogComponent } from '../dialogs/menu-edit-dialog/menu-edit-dialog.component';

@NgModule({
    declarations: [SideMenuComponent, MenuEditDialogComponent, NotifyListComponent, MenuButtonComponent],
    providers: [{ provide: SKELETON_LOADER_TOKEN, useValue: SKELETON_LOADER_CONFIG }],
    imports: [
        CommonModule,
        CustomMaterialModule,
        RouterModule,
        FlexLayoutModule,
        GlobalModule,
        CdkTreeModule,
        DynamicFieldsModule,
        MatBadgeModule,
        AppDialogModule,
        PanelToolsModule,
        FuiButtonComponent,
        ShowTooltipModule,
        OverlayModule,
        NgxSkeletonLoaderModule,
        SkeletonDirectiveModule,
        MyDateModule,
        PortalModule,
        CustomScrollDirective,
        UserListDialogModule,
        FuiIconComponent,
    ],
    exports: [SideMenuComponent],
})
export class SideMenuModule {}
